import { z } from 'zod';

export const APP_ENVS = ['development', 'staging', 'production'] as const;
export type AppEnv = (typeof APP_ENVS)[number];

const envSchema = z.object({
  VITE_APP_ENV: z.enum(APP_ENVS).default('development'),
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
  VITE_SUPABASE_PROJECT_ID: z.string().optional(),
  /** Base URL of `lastgo-api`. Required — a portal that cannot reach the API
   *  must fail at boot, not at the first click on a waiting reservation. */
  VITE_API_BASE_URL: z.string().url(),
  /** Sentry DSN. When unset, the observability layer falls back to console
   *  logging only. Configured per-environment in Vercel. */
  VITE_SENTRY_DSN: z.string().optional(),
  /** Build-time release tag (typically the git short SHA). Set by Vercel
   *  via `VITE_SENTRY_RELEASE=$VERCEL_GIT_COMMIT_SHA` if you want it. */
  VITE_SENTRY_RELEASE: z.string().optional(),
});

export type Env = z.infer<typeof envSchema>;

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('[env] invalid environment variables', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables — see console for details');
}

export const env: Env = parsed.data;

export const isProd = env.VITE_APP_ENV === 'production';
export const isStaging = env.VITE_APP_ENV === 'staging';
export const isLocal = env.VITE_APP_ENV === 'development';
